import SystemMeter from '@components/_shared/SystemMeter';
import { ReactElement } from 'react';
import storeConnector from '@store/storeConnector';
import { SiteMeta } from '@src/types/SiteMeta';
import UnitTable from '@components/_shared/UnitTable/UnitTable';
import WeatherWidget from '@components/Sun/WeatherWidget';
import PCSList from '@src/components/_shared/PCSContainer/PCSList';

interface PCSProps {
  siteMeta: SiteMeta;
}
function PCS({ siteMeta }: PCSProps): ReactElement {
  return (
    <div className='home-row'>
      <div className='fcol'>
        <SystemMeter />
        <UnitTable />
      </div>
      <div className='fcol'>
        <PCSList widgetId='pcsPV' isUnitScope />
        <WeatherWidget hideForecast={!siteMeta.ui.WeatherForecast_enable} />
      </div>
    </div>
  );
}

export default storeConnector(PCS, {
  config: ['siteMeta'],
});
